import { Trans, useTranslation } from 'react-i18next';

interface Props {
    isDragActive: boolean;
}


export const SlideFileUploadLink = ({ isDragActive }: Props) => {
    const { t } = useTranslation();

    return (
        <>
            <p className="font-accent font-w-heading text-3xl mb-2">{isDragActive ? t('Generic.DragDrop.Active') : t('Generic.DragDrop')}</p>
            <p>
                <Trans components={{ span: <span className="border-b-2 border-primary" /> }} i18nKey="Generic.DragDrop.BrowseFiles" />
            </p>
        </>
    )
};
